import { Actions } from "./actions";
import { State } from "./state";
import { initial } from "./state.initial";
import { Utils } from "../../../utils";

type TActions =
  | Actions.GetRequest
  | Actions.PostRequest
  | Actions.GetResponse
  | Actions.PostResponse
  | Actions.Edit;

const ipConfigReducer = (
  state: State.Props = initial,
  action: TActions
): State.Props => {
  switch (action.type) {
    case Actions.REQUEST_POST:
      return { ...state, loadingPost: true };
      break;
    case Actions.REQUEST_GET:
      return { ...state, loadingGet: true };
      break;
    case Actions.RESPONSE_GET:
      return {
        ...state,
        status: "OK",
        data: action.data.ipConfig,
        form: action.data.ipConfig,
        submitRequired: false,
        loadingGet: false
      };
      break;
    case Actions.RESPONSE_POST:
      return { ...state, loadingPost: false };
      break;
    case Actions.EDIT:
      let form = Object.assign({}, state.form, action.data);
      let diff = !!Object.keys(Utils.diff(form, state.data)).length;
      return { ...state, ...{ form }, ...{ submitRequired: diff } };
      break;
    default:
      return state;
  }
};

export default ipConfigReducer;
